export const lang = 'English';
export const name = 'Crazy Fried Chicken';
export const apiURL = 'https://api.crazyfriedchicken.co.uk/cfc/api/v1';
export const authURL = 'https://api.crazyfriedchicken.co.uk/cfc/api/v1';
export const ImageURL = 'https://api.crazyfriedchicken.co.uk/cfc/';
export const captchaKey = '6LewtK0qAAAAAHEHS7jtj2T7kBDKhdYeXFupS0AY';
export const postalCodeKey = 'ak_m4e9d927KVHKumGyKpUFTNdagHJ9E';
// export const postalCodeKey = 'ak_test';
